;(function(){

	var
		block = 'strength',
		html  = [
			'<div class="e-strength">',
			'	<span class="e-strength__label">Strength</span>',
			'	<div class="e-strength__bar">',
			'		<div class="e-strength__value js-strength__value"></div>',
			'	</div>',
			'</div>'
		].join(''),

		$inputs = $(bem.selector(block));

	if (!$inputs.length) {
		return;
	}

	$inputs.each(function() {

		var
			$input = $(this),
			$bar = $(html).insertAfter($input),
			$value = $bar.find(bem.selector(block, 'value')),

			update = function() {

				var
					value = $input.val(),
					score = zxcvbn(value).score,
					// returns integer from 0-4
					normalised = score/4,
					// map to % for css
					width = (1 - normalised) * 80;

				$value.css('width', (value ? width : 100) + '%');

			}.debounce(50);

		$input.on(bem.event(block, 'init'), function() {

			$input.on('keyup input change', update);
			$bar.addClass(bem.states.active);

		});
	});

	$.ajax({
		dataType: 'script',
		cache: true,
		url: '/assets/static/js/zxcvbn.js'
	}).done(function() {

		$inputs.trigger(bem.event(block, 'init'));

	});

}());
